<div class="payment-content">
    <igx-grid #paymentGrid [data]="kids | sorting" rowSelection="single" [hideRowSelectors]="true" igxGridState
        (rowSelectionChanging)="kidSelected($event, paymentDialog)">
        <igx-column field="name" header="Дете" [sortable]="true"></igx-column>
        <igx-column [dataType]="'number'" field="balance" header="Баланс" [sortable]="true"></igx-column>
    </igx-grid>
</div>
<igx-dialog #paymentDialog>
    <igx-dialog-title>{{ dialogHeader }}</igx-dialog-title>
    <igx-grid [data]="packages | sorting" width="800px" height="400px" rowSelection="single" [hideRowSelectors]="true">
        <igx-grid-toolbar>
            <igx-grid-toolbar-title>Текущо задължение {{ kid?.balance }}</igx-grid-toolbar-title>
        </igx-grid-toolbar>
        <igx-column width="50px" [editable]="false" [resizable]="false" [pinned]="true">
            <ng-template igxCell let-cell="cell">
                <button title="Добави плащане" igxIconButton="flat"
                    (click)="addPayment(cell.row.data, addPaymentDialog)">
                    <igx-icon>add_card</igx-icon>
                </button>
            </ng-template>
        </igx-column>
        <igx-column width="50px" [editable]="false" [resizable]="false" [pinned]="true">
            <ng-template igxCell let-cell="cell">
                <button title="Информация за плащанията" igxIconButton="flat"
                    (click)="editPayment(cell.row.data, editPaymentDialog)">
                    <igx-icon>info</igx-icon>
                </button>
            </ng-template>
        </igx-column>
        <igx-column field="program" header="Програма" [sortable]="true" width="250px">
            <ng-template igxCell let-cell="cell">
                {{ cell.value.name }}
            </ng-template>
        </igx-column>
        <igx-column [dataType]="'number'" field="price" header="Цена" width="80px"></igx-column>
        <igx-column field="discount" header="Отстъпка" width="90px">
            <ng-template igxCell let-cell="cell">
                {{ cell.value }} %
            </ng-template>
        </igx-column>
        <igx-column [dataType]="'number'" field="netto" header="Сума" width="100px"></igx-column>
        <igx-column [dataType]="'number'" header="Платено" width="80px">
            <ng-template igxCell let-cell="cell">
                {{ paid(cell.row.data) }}
            </ng-template>
        </igx-column>
        <igx-column [dataType]="'number'" header="Остатък" width="80px">
            <ng-template igxCell let-cell="cell">
                {{ cell.row.data.netto - paid(cell.row.data) }}
            </ng-template>
        </igx-column>
    </igx-grid>
    <igx-dialog-actions>
        <button igxButton (click)="paymentDialog.close()">Приключи</button>
    </igx-dialog-actions>
</igx-dialog>
<igx-dialog #addPaymentDialog>
    <igx-dialog-title>Плащане за {{kid?.name}} по програма {{currentPackage?.program?.name}}</igx-dialog-title>
    <form [formGroup]="paymentForm" (ngSubmit)="paymentSubmit(addPaymentDialog)" class="add-payment-dialog">
        <igx-input-group type="border">
            <label igxLabel>Сума</label>
            <input type="number" igxInput [igxTextSelection]="true" name="amount" formControlName="amount" />
        </igx-input-group>
        <igx-date-picker name="date" formControlName="date" type="border" [maxValue]="maxDate">
            <label igxLabel>Дата на плащане</label>
        </igx-date-picker>
        <igx-select name="source" formControlName="source" type="border">
            <label igxLabel>Източник</label>
            @for (source of paymentSources | sorting; track source.id){
            <igx-select-item [value]="source.id">
                {{ source.name }}
            </igx-select-item>
            }
        </igx-select>
        <igx-dialog-actions>
            <button igxButton type="button" (click)="addPaymentDialog.close()">ОТКАЖИ</button>
            <button igxButton type="submit" [disabled]="!paymentForm.valid">{{ dialogText }}</button>
        </igx-dialog-actions>
    </form>
</igx-dialog>
<igx-dialog #editPaymentDialog>
    <igx-grid [data]="currentPackage?.payments | sorting" width="800px" height="400px">
        <igx-column width="50px" [editable]="false" [resizable]="false" [pinned]="true">
            <ng-template igxCell let-cell="cell">
                <button title="Обнови плащане" igxIconButton="flat"
                    (click)="updatePayment(cell.row.data, addPaymentDialog)">
                    <igx-icon>refresh</igx-icon>
                </button>
            </ng-template>
        </igx-column>
        <igx-column width="50px" [editable]="false" [resizable]="false" [pinned]="true">
            <ng-template igxCell let-cell="cell">
                <button title="Изтрий" igxIconButton="flat"
                    (click)="deletePayment(cell.row.data, deletePaymentDialog)">
                    <igx-icon>delete</igx-icon>
                </button>
            </ng-template>
        </igx-column>
        <igx-column width="80px" [dataType]="'number'" field="amount" header="Сума" [sortable]="true"></igx-column>
        <igx-column width="100px" [dataType]="'date'" field="date" header="Дата" [sortable]="true"></igx-column>
        <igx-column field="packages" header="Програма" [sortable]="true">
            <ng-template igxCell let-cell="cell">
                {{ currentPackage?.program?.name }}
            </ng-template>
        </igx-column>
        <igx-column field="source" header="Начин на плащане" [sortable]="true">
            <ng-template igxCell let-cell="cell">
                {{ cell.value.name }}
            </ng-template>
        </igx-column>
        <igx-column field="user" header="Добавено от" [sortable]="true">
            <ng-template igxCell let-cell="cell">
                {{ cell.value.userName }}
            </ng-template>
        </igx-column>
    </igx-grid>
    <igx-dialog-actions>
        <button igxButton (click)="editPaymentDialog.close()">Приключи</button>
    </igx-dialog-actions>
</igx-dialog>
<igx-dialog #deletePaymentDialog>
    <igx-dialog-title>
        Потвърдете изтриването на плащане за {{payment?.amount}} лв.
    </igx-dialog-title>
    <igx-dialog-actions>
        <button igxButton (click)="deletePaymentDialog.close()">Откажи</button>
        <button igxButton (click)="doDeletePayment(deletePaymentDialog)">Потвърди</button>
    </igx-dialog-actions>
</igx-dialog>